module.exports = __webpack_public_path__ + "static/media/card_brand_ben.322cd9a1.svg";